// public

import {
  PERMISSION_ACCESS_PERMISSIONS,
  PERMISSION_CHANGE_AML_PREFERENCE,
  PERMISSION_DASHBOARD,
  PERMISSION_EDIT_BANK_DETAILS, PERMISSION_NOTIFICATION_SETTINGS,
  PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE
} from "./permissions";

export const LINK_ACCESS_DENIED = '/403';
export const LINK_SIGN_IN = '/sign-in';
export const LINK_FORGOT_PASSWORD = '/forgot-password';
export const LINK_RECOVERY_TOKEN = '/recovery-token';
export const LINK_START = '/start';
export const LINK_START_STEP = '/start/step';
export const LINK_START_VERIFICATION = '/start/verification';
export const LINK_START_FIRST = LINK_START_STEP + '/1';
export const LINK_START_LAST = LINK_START_STEP + '/6';
export const LINK_BLOCKED = '/blocked';
export const LINK_RESET_SECURITY_VERIFICATION = '/reset-security-verification';
export const LINK_SECURITY_VERIFICATION = '/security-verification';

// merchant

export const LINK_DASHBOARD = '/dashboard';
export const LINK_WITHDRAW = '/dashboard/withdraw';

export const LINK_TRANSACTIONS = '/transactions';
export const LINK_TRANSACTION_DETAILS = '/transactions/details';
export const LINK_TRANSACTION_REFUND = '/transactions/refund';
export const LINK_REFUND_DETAILS = '/refund';

export const LINK_PBL = '/payment-link';
export const LINK_PBL_DETAILS = '/payment-link/details';
export const LINK_PBL_CREATE = '/payment-link/create';
export const LINK_PBL_REFUND = '/payment-link/refund';

export const LINK_TERMINALS = '/terminals';
export const LINK_TERMINALS_DASHBOARD = '/terminals/dashboard';
export const LINK_TERMINALS_HISTORY = '/terminals/history';
export const LINK_TERMINALS_LIST = '/terminals/list';
export const LINK_TERMINALS_DETAILS = '/terminals/list/details';
export const LINK_TERMINALS_BUY = '/terminals/buy';

export const LINK_SETTINGS = '/settings';

export const LINK_MANAGEMENT = '/settings/management';
export const LINK_MANAGEMENT_ACCOUNTS = '/settings/management/accounts';
export const LINK_BANK_ACCOUNT_CREATE = `${LINK_MANAGEMENT_ACCOUNTS}?id=create`;
export const LINK_MANAGEMENT_SETTLEMENTS = '/settings/management/settlements-and-refunds';
export const LINK_MANAGEMENT_AML = '/settings/management/buyer-aml-preferences';

export const LINK_DEVELOPER_OPTIONS = '/settings/developer-options';
export const LINK_NOTIFICATION_SETTINGS = '/settings/developer-options/notification-settings';
export const LINK_PROMOTION_SETTINGS = '/settings/developer-options/promotion-settings';

export const LINK_HELP = '/settings/help';

export const ACCOUNT_SETTINGS = '/account/settings';
export const ACCOUNT_SETTINGS_PROFILE = '/account/settings/profile';
export const ACCOUNT_SETTINGS_AUTH = '/account/settings/auth';
export const ACCOUNT_SETTINGS_NOTIFICATIONS = '/account/settings/notifications';
export const ACCOUNT_SETTINGS_USERS = '/account/settings/users';


// admin

export const LINK_MPOS_TERMINALS = '/mpos-terminals';
export const LINK_MPOS_CREDENTIAL = '/mpos-terminals/credential';
export const LINK_MPOS_TERMINALS_ORDER = '/mpos-terminals/order';
export const LINK_AUDITORS = '/auditors';
export const LINK_REFERRAL_ADMIN = '/admin-referral';
export const LINK_DELETE_ACCOUNT = '/settings/delete-account';
export const LINK_ORDERS = '/orders';
export const LINK_PROFILE = '/profile';
export const LINK_WITHDRAWAL = '/withdrawal';
export const LINK_WIDGETS = '/widgets';
export const LINK_WIDGETS_NEW = '/widgets/new';

// admin

export const LINK_ADMIN_STATUS = '/status';
export const LINK_ADMIN_STATISTIC = '/statistic';
export const LINK_ADMIN_LOGS_ITEM = '/logs/';
export const LINK_ADMIN_EARNED_MONEY = '/earned-money';
export const LINK_ADMIN_TRANSACTION_COLLISION = '/blockchain';
export const LINK_ADMIN_ACCOUNTS = '/accounts';
export const LINK_ADMIN_ACCOUNTS_KYC = '/kyc';
export const LINK_ADMIN_ACCOUNT_KYC_ITEM = '/kyc/';
export const LINK_ADMIN_ACCOUNT_ITEM = '/accounts/';
export const LINK_ADMIN_MPOS_CREDENTIALS = '/admin-mpos-credentials/';
export const LINK_ADMIN_FAILED_AUCTIONS = '/failed-auctions/';
export const LINK_ADMIN_ORDERED_TERMINALS = '/ordered-terminals';
export const LINK_ADMIN_TERMINALS = '/admin-terminals';
export const LINK_ADMIN_TRANSACTIONS = '/admin-transactions';
export const LINK_ADMIN_WITHDRAWS = '/admin-withdraws';
export const LINK_ADMIN_STATEMENTS = '/admin-statements';
export const LINK_ADMIN_STABLECOINS_WITHDRAW = '/admin-stablecoins-withdraws';
export const LINK_ADMIN_EXCHANGE_RATES = '/exchange-rates';
export const LINK_ADMIN_EXCHANGE_ORDERS = '/exchange-orders';
export const LINK_ADMIN_COMMISSIONS = '/commissions';
export const LINK_ADMIN_AUCTIONS = '/auctions';
export const LINK_ADMIN_DEPOSITS_STATUS = '/deposits-status';
export const LINK_ADMIN_ARBITRAGE_DEPOSITS = '/arbitrage-deposits';
export const LINK_ADMIN_EXCHANGE_DEPOSITS = '/exchange-deposits';
export const LINK_ADMIN_MERCHANT_STATISTIC = '/merchant-statistic';
export const LINK_ADMIN_MERCHANT_REFUNDS = '/admin-merchant-refunds';
export const LINK_ADMIN_OPEN_PAYD_CONFIG = '/admin-open-payd-config';
export const LINK_ADMIN_OPEN_PAYD_ACCOUNTS = '/admin-open-payd-accounts';
export const LINK_ADMIN_ACCOUNT_OPEN_PAYD_ITEM = '/admin-open-payd-accounts/';
export const LINK_ADMIN_SETTINGS = '/admin-settings';
export const LINK_ADMIN_HELP = '/admin-help';
export const LINK_ADMIN_PAYOUT = '/admin-payout-individual';
export const LINK_ADMIN_PAYOUT_MERCHANT = '/admin-payout-merchant';
export const LINK_ADMIN_PAYOUT_GROUPS = '/admin-payout-nium';
export const LINK_ADMIN_PAYOUT_NIUM_GROUP_INFO = '/admin-payout-nium-group-info';
export const LINK_ADMIN_PAYOUT_NIUM_TRANSACTION_ADD = '/admin-payout-nium-transaction-add';
export const LINK_ADMIN_PAYOUT_NIUM_REMITTERS = '/admin-payout-nium-remitters';
export const LINK_ADMIN_PAYOUT_NIUM_REMITTER_ADD = '/admin-payout-nium-remitters/add';
export const LINK_ADMIN_PAYOUT_VERTO_GROUP_INFO = '/admin-payout-verto-group-info';
export const LINK_ADMIN_PAYOUT_VERTO_TRANSACTION_ADD = '/admin-payout-verto-transaction-add';
export const LINK_ADMIN_PAYOUT_VERTO_MANUAL_UPDATE = '/admin-payout-verto-manual-update';
export const LINK_ADMIN_PROMO_FEES = '/admin-promo-fees';
export const LINK_ADMIN_FINERY = '/admin-finery';
export const LINK_ADMIN_REFUNDS = '/admin-refunds';

export const LINK_REFERRAL = '/referral';
export const LINK_REFERRAL_DASHBOARD = '/referral/dashboard';
export const LINK_REFERRAL_MERCHANTS = '/referral/merchants';
export const LINK_REFERRAL_ADD_MERCHANT = '/referral/merchants/add';
export const LINK_REFERRAL_TRX_ROOT = '/referral/transactions';
export const LINK_REFERRAL_PAYOUT = '/referral/payout';


const STATUS = {name: 'Status', link: LINK_ADMIN_STATUS};
const STATISTIC = {name: 'Statistic', link: LINK_ADMIN_STATISTIC};
const TRX = {name: 'Transactions', link: LINK_ADMIN_TRANSACTIONS};
const AUCTIONS = {name: 'Auctions', link: LINK_ADMIN_AUCTIONS};
const KYC = {name: 'KYC', link: LINK_ADMIN_ACCOUNTS_KYC};
const STATEMENTS = {name: 'Statements', link: LINK_ADMIN_STATEMENTS};

export const NAV_LINKS_OF_AUDITOR = [
  STATUS,
  STATISTIC,
  TRX,
  AUCTIONS,
  KYC,
  STATEMENTS
];

export const NAV_LINKS_OF_ADMIN = [
  STATUS,
  STATISTIC,
  TRX,
  {name: 'Refunds', link: LINK_ADMIN_MERCHANT_REFUNDS},
  {name: 'Blockchain', link: LINK_ADMIN_TRANSACTION_COLLISION},
  AUCTIONS,
  {name: 'Earned money', link: LINK_ADMIN_EARNED_MONEY},
  {name: 'Accounts', link: LINK_ADMIN_ACCOUNTS},
  KYC,
  {name: 'Payout', link: LINK_ADMIN_PAYOUT},
  {name: 'Payout | Merchants', link: LINK_ADMIN_PAYOUT_MERCHANT},
  {name: 'Payout | Groups', link: LINK_ADMIN_PAYOUT_GROUPS},
  {name: 'Promo Fees', link: LINK_ADMIN_PROMO_FEES},
  {name: 'Finery', link: LINK_ADMIN_FINERY},
  {name: 'Withdrawals', link: LINK_ADMIN_WITHDRAWS},
  {name: 'Stablecoin withdrawals', link: LINK_ADMIN_STABLECOINS_WITHDRAW},
  {name: 'Ordered terminals', link: LINK_ADMIN_ORDERED_TERMINALS},
  {name: 'Terminals', link: LINK_ADMIN_TERMINALS},
  {name: 'Merchant statistic', link: LINK_ADMIN_MERCHANT_STATISTIC},
  {name: 'Master Merchant', link: LINK_REFERRAL_ADMIN},
  STATEMENTS,
  {name: 'Settings', link: LINK_ADMIN_SETTINGS},
  {name: 'Help', link: LINK_ADMIN_HELP}
];

export const MERCHANT_TERMINAL_SUBMENU = [
  {
    id: 'terminalsDashboard',
    name: 'Dashboard',
    link: LINK_TERMINALS_DASHBOARD,
  },
  {
    id: 'terminalsHistory',
    name: 'Transaction History',
    link: LINK_TERMINALS_HISTORY,
  },
  {
    id: 'terminalsList',
    name: 'My Terminals',
    link: LINK_TERMINALS_LIST,
  },
  {
    id: 'terminalsBuy',
    name: 'Buy Terminals',
    link: LINK_TERMINALS_BUY,
  }
];

export const MERCHANT_SETTINGS_SUBMENU = [
  {
    id: 'management',
    link: LINK_MANAGEMENT,
    name: 'Management',
    permissions: [
      PERMISSION_EDIT_BANK_DETAILS,
      PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE,
      PERMISSION_CHANGE_AML_PREFERENCE
    ]
  },
  {
    id: 'developerOptions',
    link: LINK_DEVELOPER_OPTIONS,
    name: 'Developer Options',
  },
  {
    id: 'helpAndSupport',
    link: LINK_HELP,
    name: 'Help and Support',
  }
];

export const MERCHANT_MANAGEMENT_SUBMENU = [
  {
    id: 'withdrawalAccounts',
    link: LINK_MANAGEMENT_ACCOUNTS,
    name: 'Withdrawal accounts',
    permissions: [PERMISSION_EDIT_BANK_DETAILS],
    // disabled: !isUserAccessed(PERMISSION_EDIT_BANK_DETAILS),
  },
  {
    id: 'settlementsAndRefunds',
    link: LINK_MANAGEMENT_SETTLEMENTS,
    name: 'Settlements and refunds',
    permissions: [PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE],
    // disabled: !isUserAccessed(PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE),
  },
  {
    id: 'buyerAMLPreference',
    link: LINK_MANAGEMENT_AML,
    name: 'Buyer AML Preference',
    permissions: [PERMISSION_CHANGE_AML_PREFERENCE],
    // disabled: !isUserAccessed(PERMISSION_CHANGE_AML_PREFERENCE),
  }
];

export const MERCHANT_ACCOUNT_SETTINGS_SUBMENU = [
  {
    id: 'profile',
    link: ACCOUNT_SETTINGS_PROFILE,
    name: 'Account Data'
  },
  {
    id: 'auth',
    link: ACCOUNT_SETTINGS_AUTH,
    name: 'Authorisation',
    // permissions: [PERMISSION_ACCESS_PERMISSIONS],
  },
  {
    id: 'notifications',
    link: ACCOUNT_SETTINGS_NOTIFICATIONS,
    name: 'Notifications',
    permissions: [PERMISSION_NOTIFICATION_SETTINGS],
  },
  {
    id: 'users',
    link: ACCOUNT_SETTINGS_USERS,
    name: 'Users',
    permissions: [PERMISSION_ACCESS_PERMISSIONS],
  }
];
